"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.YoutubePlayer = void 0;
var PlayerDecorator_1 = require("../../decorator/PlayerDecorator");
var LoggerFactory_1 = require("../../factory/LoggerFactory");
var YoutubePlayer = (function (_super) {
    __extends(YoutubePlayer, _super);
    function YoutubePlayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.logger = LoggerFactory_1.LoggerFactory.createLogger();
        return _this;
    }
    YoutubePlayer.prototype.play = function () {
        var playerInstance = this.getPlayerInstance();
        try {
            playerInstance.playVideo();
        }
        catch (err) {
            this.logger.error(err);
        }
    };
    YoutubePlayer.prototype.mute = function () {
        this.logger.log('[CLIENT]: Client youtube mute() is not implemented!');
    };
    YoutubePlayer.prototype.pause = function () {
        var playerInstance = this.getPlayerInstance();
        try {
            playerInstance.pauseVideo();
        }
        catch (err) {
            this.logger.error('[CLIENT]: Youtube client pause error', err);
        }
    };
    YoutubePlayer.prototype.getCurrentPosition = function () {
        var playerInstance = this.getPlayerInstance();
        try {
            return playerInstance.getCurrentTime();
        }
        catch (err) {
            this.logger.error('[CLIENT]: Get current youtube time error ', err);
        }
        return 0;
    };
    YoutubePlayer.prototype.fastSeekToPosition = function (position) {
        var playerInstance = this.getPlayerInstance();
        try {
            playerInstance.seekTo(position);
        }
        catch (error) {
            this.logger.error('[CLIENT]: Fast seek error ', error);
        }
    };
    YoutubePlayer.prototype.isPlaying = function () {
        var playerInstance = this.getPlayerInstance();
        return true;
    };
    YoutubePlayer.prototype.stop = function () {
        this.comp.stop();
    };
    YoutubePlayer.prototype.changePlaybackRate = function (rate) {
        var playerInstance = this.getPlayerInstance();
        try {
            playerInstance.setPlaybackRate(rate);
        }
        catch (err) {
            this.logger.error('[CLIENT]: Youtube seek error ', err);
        }
    };
    YoutubePlayer.prototype.getPlayerId = function () {
        return this.comp.getPlayerId();
    };
    YoutubePlayer.prototype.setVolume = function (volume) {
        console.log('[CLIENT]: Set volume for youtube player is not implemented !', volume);
    };
    return YoutubePlayer;
}(PlayerDecorator_1.PlayerDecorator));
exports.YoutubePlayer = YoutubePlayer;
//# sourceMappingURL=YoutubePlayer.js.map